import React from "react";
import PropTypes from "prop-types";
import Minimize from "../resources/Minimise.png";
import Close from "../resources/CloseIcon.png";
import ChatIcon from "../resources/ChatIcon.png";
const ChatHeader = props => {
  const buClass = props.businessUnit === 2 ? "light-red-gradient" : "light-blue-gradient";
  return /*#__PURE__*/React.createElement("div", {
    id: "chat-header",
    className: buClass
  }, /*#__PURE__*/React.createElement("div", null, "Let's Chat", " ", /*#__PURE__*/React.createElement("img", {
    alt: "Chat Bubble",
    src: ChatIcon,
    className: "lets-chat-image"
  })), /*#__PURE__*/React.createElement("div", {
    id: "minimize-button"
  }, /*#__PURE__*/React.createElement("img", {
    src: Minimize,
    onClick: props.onMinimizeClick,
    alt: "Minimize Chat",
    title: "Minimize Chat"
  }), props.showCloseButton ? /*#__PURE__*/React.createElement("img", {
    src: Close,
    onClick: props.onCloseClick,
    alt: "End Chat",
    title: "End Chat"
  }) : null));
};
ChatHeader.propTypes = {
  businessUnit: PropTypes.number,
  showCloseButton: PropTypes.bool,
  onMinimizeClick: PropTypes.func,
  onCloseClick: PropTypes.func
};
export default ChatHeader;